import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { addEventListener, warning } from '@cloud-sn/v-utils';
import { preventEvent, isTargetEvent, getPositionAndDragOffset, getMousePosition, getHandleCenterPosition } from '../utils';
import SliderHandle from '../handle';
import CalcMixin from './calc';
import Marks from '../marks';
import Steps from '../steps';
export default {
  provide: function provide() {
    return {
      sliderRoot: this
    };
  },
  mixins: [CalcMixin],
  props: {
    prefixCls: {
      type: String,
      default: 'v-slider'
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    step: {
      type: [Number, Boolean],
      default: 1
    },
    marks: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    included: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    handle: {
      type: Function,
      default: function _default(_ref) {
        var className = _ref.className,
            style = _ref.style,
            ref = _ref.ref,
            refInFor = _ref.refInFor,
            on = _ref.on,
            attrs = _objectWithoutProperties(_ref, ["className", "style", "ref", "refInFor", "on"]);

        var h = this.$createElement;
        return h(SliderHandle, _mergeJSXProps([{}, {
          class: className,
          style: style,
          attrs: attrs,
          ref: ref,
          refInFor: refInFor,
          on: on
        }]));
      }
    },
    dots: {
      type: Boolean,
      default: false
    },
    vertical: {
      type: Boolean,
      default: false
    },
    handleStyle: {
      type: [Array, Object],
      default: function _default() {
        return {};
      }
    },
    trackStyle: {
      type: [Array, Object],
      default: function _default() {
        return {};
      }
    },
    railStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    dotStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    activeDotStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    autofocus: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      sliderRef: null,
      sliderDocument: null,
      dragging: false,
      dragOffset: 0,
      cancelEvents: {
        touchmove: null,
        touchend: null,
        mousemove: null,
        mouseend: null
      }
    };
  },
  computed: {
    classes: function classes() {
      var _ref2;

      var prefixCls = this.prefixCls,
          disabled = this.disabled,
          vertical = this.vertical,
          marks = this.marks;
      return _ref2 = {}, _defineProperty(_ref2, prefixCls, true), _defineProperty(_ref2, "".concat(prefixCls, "-with-marks"), Object.keys(marks).length), _defineProperty(_ref2, "".concat(prefixCls, "-disabled"), disabled), _defineProperty(_ref2, "".concat(prefixCls, "-vertical"), vertical), _ref2;
    }
  },
  mounted: function mounted() {
    var sliderRef = this.$refs.sliderRef,
        validateMinMaxStep = this.validateMinMaxStep;

    if (sliderRef) {
      this.sliderRef = sliderRef;
      this.sliderDocument = sliderRef.ownerDocument;
    }

    validateMinMaxStep();
  },
  beforeDestroy: function beforeDestroy() {
    var removeDocumentEvents = this.removeDocumentEvents;
    removeDocumentEvents();
  },
  methods: {
    validateMinMaxStep: function validateMinMaxStep() {
      if (process.env.NODE_ENV !== 'production') {
        var step = this.step,
            max = this.max,
            min = this.min;
        warning(step && Math.floor(step) === step ? (max - min) % step === 0 : true, 'Slider[max] - Slider[min] = (%s) should be a multiple of Slider[step] = (%s)', max - min, step);
      }
    },
    renderTrack: function renderTrack(_ref3) {
      var className = _ref3.className,
          _ref3$offset = _ref3.offset,
          offset = _ref3$offset === void 0 ? 0 : _ref3$offset,
          _ref3$length = _ref3.length,
          length = _ref3$length === void 0 ? 0 : _ref3$length;
      var h = this.$createElement;
      var included = this.included,
          vertical = this.vertical,
          trackStyle = this.trackStyle;
      var style = vertical ? {
        bottom: "".concat(offset, "%"),
        height: "".concat(length, "%")
      } : {
        left: "".concat(offset, "%"),
        width: "".concat(length, "%")
      };
      return included ? h("div", {
        "class": className,
        "style": [trackStyle[0] || trackStyle, style]
      }) : null;
    },
    addTouchEvents: function addTouchEvents() {// const { cancelEvents } = this;
      // TODO:
    },
    addDocumentMouseEvents: function addDocumentMouseEvents() {
      var sliderDocument = this.sliderDocument,
          onMouseMove = this.onMouseMove,
          onEnd = this.onEnd,
          cancelEvents = this.cancelEvents;
      cancelEvents.mousemove = addEventListener(sliderDocument, 'mousemove', onMouseMove);
      cancelEvents.mouseup = addEventListener(sliderDocument, 'mouseup', onEnd);
    },
    removeDocumentEvents: function removeDocumentEvents() {
      var cancelEvents = this.cancelEvents;
      Object.keys(cancelEvents).forEach(function (k) {
        var listener = cancelEvents[k];

        if (listener) {
          listener.remove();
        }
      });
    },
    onTouchStart: function onTouchStart(e) {
      preventEvent(e);
    },
    onMouseDown: function onMouseDown(e) {
      var vertical = this.vertical,
          onStart = this.onStart,
          sliderHandleRef = this.$refs.sliderHandleRef,
          removeDocumentEvents = this.removeDocumentEvents,
          addDocumentMouseEvents = this.addDocumentMouseEvents; // only left mouse  click

      if (e.button !== 0) {
        return;
      }

      preventEvent(e);

      var _getPositionAndDragOf = getPositionAndDragOffset(e, vertical, isTargetEvent(e, sliderHandleRef)),
          position = _getPositionAndDragOf.position,
          dragOffset = _getPositionAndDragOf.dragOffset;

      this.dragOffset = dragOffset;
      removeDocumentEvents();
      onStart(e, position);
      addDocumentMouseEvents();
    },
    onMouseMove: function onMouseMove(e) {
      var onMove = this.onMove,
          dragOffset = this.dragOffset,
          vertical = this.vertical;
      var position = getMousePosition(e, vertical);
      onMove(e, position - dragOffset);
    },
    onMouseUp: function onMouseUp() {},
    onFocus: function onFocus(e) {
      var onStart = this.onStart,
          vertical = this.vertical;
      this.dragOffset = 0;
      onStart(e, getHandleCenterPosition(vertical, e.target));
      this.$emit('focus', e);
    },
    onBlur: function onBlur(e) {
      var onEnd = this.onEnd;
      onEnd(e);
      this.$emit('blur', e);
    },
    focus: function focus() {
      var disabled = this.disabled,
          sliderHandleRef = this.$refs.sliderHandleRef;

      if (!disabled && sliderHandleRef && sliderHandleRef.length > 0) {
        sliderHandleRef[0].focus();
      }
    },
    blur: function blur() {
      var disabled = this.disabled,
          sliderHandleRef = this.$refs.sliderHandleRef;

      if (!disabled && sliderHandleRef && sliderHandleRef.length > 0) {
        sliderHandleRef[0].blur();
      }
    }
  },
  render: function render() {
    var h = arguments[0];
    var prefixCls = this.prefixCls,
        classes = this.classes,
        railStyle = this.railStyle,
        disabled = this.disabled,
        onTouchStart = this.onTouchStart,
        onMouseDown = this.onMouseDown,
        onMouseUp = this.onMouseUp,
        onFocus = this.onFocus,
        onBlur = this.onBlur,
        _this$tracksAndHandle = this.tracksAndHandles,
        tracks = _this$tracksAndHandle.tracks,
        handles = _this$tracksAndHandle.handles,
        getLowerBound = this.getLowerBound,
        getUpperBound = this.getUpperBound;
    var on = disabled ? null : {
      touchstart: onTouchStart,
      mousedown: onMouseDown,
      mouseup: onMouseUp,
      focus: onFocus,
      blur: onBlur
    };
    var upperBound = getUpperBound();
    var lowerBound = getLowerBound();
    return h("div", {
      "ref": "sliderRef",
      "class": classes,
      "on": _objectSpread({}, on)
    }, [h("div", {
      "class": "".concat(prefixCls, "-rail"),
      "style": [railStyle]
    }), tracks, h(Steps, {
      "attrs": {
        "lower-bound": lowerBound,
        "upper-bound": upperBound
      }
    }), handles, h(Marks, {
      "attrs": {
        "lower-bound": lowerBound,
        "upper-bound": upperBound
      }
    })]);
  }
};